const MatchTeamGameRouter = {
    path: '/match/:matchId/team/:teamId/game/:gameId',
    name: 'MatchTeamGame',
    meta: {
        title: '球队比赛详情'
    },
    component: () => import('@/views/match-team-game/index'),
    redirect: '/match/:matchId/team/:teamId/game/:gameId/roster',
    children: [
        {
            path: '/match/:matchId/team/:teamId/game/:gameId/roster',
            name: 'MatchTeamGameRoster',
            meta: {
                title: '出场名单'
            },
            component: () => import('@/views/match-team-game/roster')
        },
        {
            path: '/match/:matchId/team/:teamId/game/:gameId/battle-array',
            name: 'MatchTeamGameBattleArray',
            meta: {
                title: '出场阵容'
            },
            component: () => import('@/views/match-team-game/battle-array')
        },
        {
            path: '/match/:matchId/team/:teamId/game/:gameId/clothes-color',
            name: 'MatchTeamGameClothesColor',
            meta: {
                title: '队服颜色'
            },
            component: () => import('@/views/match-team-game/clothes-color')
        },
        {
            path: '/match/:matchId/game/:gameId/registration',
            name: 'MatchTeamGameRegistration',
            meta: {
                title: '比赛检录'
            },
            component: () => import('@/views/match-team-game/registration')
        },
        {
            path: '/match/:matchId/game/:gameId/competition-supervise',
            name: 'MatchTeamGameCompetitionSupervise',
            meta: {
                title: '比赛监督'
            },
            component: () => import('@/views/match-team-game/competition-supervise')
        },
        {
            path: '/match/:matchId/game/:gameId/confirmation',
            name: 'MatchTeamGameConfirmation',
            meta: {
                title: '赛后确认'
            },
            component: () => import('@/views/match-team-game/confirmation')
        },
        {
            path: '/match/:matchId/game/:gameId/confirmation',
            name: 'MatchTeamGameRefereeReprot',
            meta: {
                title: '裁判报告'
            },
            component: () => import('@/views/match-team-game/confirmation')
        },
        {
            path: '/match/:matchId/game/:gameId/note',
            name: 'MatchTeamGameRefereeNote',
            meta: {
                title: '特别备注'
            },
            component: () => import('@/views/match-team-game/note')
        }
    ]
}

export default MatchTeamGameRouter